import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTwilio } from '../../contexts/TwilioContext';
import styles from './multiple-incoming-calls.module.css';
import { PhoneIcon } from '../icons/phone-icon';
import { hasTwilioAccess } from '../../utils/userRole';

const MultipleIncomingCalls = () => {
  const navigate = useNavigate();
  const { 
    incomingCalls, 
    acceptCallById, 
    rejectCallById,
    totalIncomingCalls 
  } = useTwilio();
  
  const [isMinimized, setIsMinimized] = React.useState(false);
  
  // 🎵 Efecto de sonido para múltiples llamadas (debe estar antes de los returns)
  useEffect(() => {
    if (totalIncomingCalls > 1) {
      console.log(`📞 Mostrando ${totalIncomingCalls} llamadas simultáneas`);
    }
  }, [totalIncomingCalls]);

  // 🚫 No mostrar si el usuario no tiene acceso a Twilio
  if (!hasTwilioAccess()) return null;

  // Solo mostrar si hay llamadas entrantes
  if (totalIncomingCalls === 0) return null;

  // Si solo hay una llamada, usar el modal original
  if (totalIncomingCalls === 1) return null;

  const handleAccept = (callId) => {
    console.log(`✅ Aceptando llamada ${callId}`);
    acceptCallById(callId);
  };

  const handleReject = (callId) => {
    console.log(`❌ Rechazando llamada ${callId}`);
    rejectCallById(callId);
  };

  const handleExpedienteClick = (expedienteId) => {
    if (expedienteId) {
      console.log(`📁 Navegando al expediente ${expedienteId}`);
      navigate(`/record/${expedienteId}`);
    }
  };

  return (
    <div className={styles.multipleCallsOverlay}>
      <div className={`${styles.multipleCallsContainer} ${isMinimized ? styles.minimized : ''}`}>
        <div className={styles.header} onClick={() => isMinimized && setIsMinimized(false)}>
          <button
            onClick={(e) => {
              e.stopPropagation();
              setIsMinimized(!isMinimized);
            }}
            className={styles.minimizeButton}
            title={isMinimized ? "Expandir" : "Minimizar"}
          >
            {isMinimized ? '▲' : '▼'}
          </button>
          <h3>📞 {totalIncomingCalls} Llamadas Entrantes</h3>
          <p>Tienes múltiples llamadas esperando</p>
        </div>
        
        <div className={styles.callsList}>
          {incomingCalls.map((callInfo, index) => (
            <div key={callInfo.id} className={styles.callItem}>
              <div className={styles.callInfo}>
                <div className={styles.callIcon}>
                  <PhoneIcon />
                  {callInfo.contactInfo && callInfo.contactInfo.isKnown && (
                    <div className={styles.contactBadge}>✓</div>
                  )}
                </div>
                <div className={styles.callDetails}>
                  <span className={styles.callNumber}>
                    {callInfo.contactInfo?.name || callInfo.from}
                  </span>
                  {callInfo.contactInfo?.type && (
                    <span className={styles.callLabel}>
                      {callInfo.contactInfo.type}
                    </span>
                  )}
                  <span className={styles.callTime}>
                    {callInfo.timestamp.toLocaleTimeString()}
                  </span>
                  {callInfo.contactInfo?.expediente && (
                    <span 
                      className={styles.expedienteLink}
                      onClick={() => handleExpedienteClick(callInfo.contactInfo.expedienteId)}
                      title="Click para abrir el expediente"
                    >
                      📁 {callInfo.contactInfo.expediente}
                    </span>
                  )}
                  {callInfo.contactInfo?.details && !callInfo.contactInfo?.expediente && (
                    <span className={styles.callSubDetails}>
                      📋 {callInfo.contactInfo.details}
                    </span>
                  )}
                  {callInfo.contactInfo?.tieneLlamadasSalientesPerdidas && (
                    <span className={styles.outgoingMissedIndicator}>
                      📞➡️❌ No contestó {callInfo.contactInfo.tiempoUltimaLlamadaSalientePerdida}
                    </span>
                  )}
                </div>
              </div>
              
              <div className={styles.callActions}>
                <button
                  onClick={() => handleAccept(callInfo.id)}
                  className={styles.acceptButton}
                  title="Aceptar llamada"
                >
                  ✓
                </button>
                <button
                  onClick={() => handleReject(callInfo.id)}
                  className={styles.rejectButton}
                  title="Rechazar llamada"
                >
                  ✕
                </button>
              </div>
            </div>
          ))}
        </div>
        
        <div className={styles.footer}>
          <p className={styles.hint}>
            💡 Puedes aceptar múltiples llamadas y alternar entre ellas
          </p>
        </div>
      </div>
    </div>
  );
};

export default MultipleIncomingCalls;